<template>
    <div class="info-modal hide">

        <div class="info-modal-content">
            <button class="close-btn" @click="closeModal"><img src="@/assets/img/modal/close.svg" /></button>

            <div class="basic-content">
                <h2>ADHD-RS-IV<sup>1</sup></h2>

                <p><b>The ADHD-RS-IV rates the severity of each ADHD symptom based on DSM-IV criteria,</b> scored by
                    trained
                    clinicians based on parent interviews. The ADHD-RS-IV assesses home behavior using 2 subscales:
                    inattention (9 items) and hyperactivity-impulsivity (9 items) on a 4-point scale. </p>

                <p><b style="color:#30368C">0 = No issues <br />
                        1 = Mild issues<br />
                        2 = Moderate issues<br />
                        3 = Severe issues
                    </b>
                </p>





            </div>
            <div class="refs">
                <p><b>References: 1.</b> DuPaul GJ, Power TJ, Anastopoulos AD, Reid R. (1998). ADHD Rating Scale-IV:
                    Checklists, norms, and clinical interpretation. New York: Guilford.</p>
            </div>

        </div>

    </div>
</template>

<script>
export default {


    props: {
        showModal: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        if (this.showModal == true) {
            document.body.classList.add("overflow")
            this.$el.classList.remove('hide')
        }
    },
    watch: {
        showModal(newValue, oldValue) {
            console.log(newValue);
            if (newValue === true) {
                this.modalActive();
            }
        }
    },

    methods: {
        modalActive: function () {
            document.body.classList.add("overflow")
            this.$el.classList.remove('hide')
        },

        closeModal() {
            document.body.classList.remove("overflow")
            this.$el.classList.add('hide')
            this.$emit('closeModal')
        },
    }

}
</script>

<style lang="scss" scoped>
.info-modal-content .basic-content {
    padding-right: 50px;
}

.info-modal-content {
    p {
        font-size: 20px;
        line-height: 1.2;
    }
}
</style>